import React from "react";
import config from "../../../config";

export default function AppStoreLink({
  href,
  tabIndex,
  className,
}: {
  href?: string;
  tabIndex?: number;
  className?: string;
}) {
  const appleStoreImageUrl = `${config.ASSETS_URL}/static/ios-appstore-badge-black-2025.svg`;

  if (!href) {
    return <img src={appleStoreImageUrl} alt='Download on the App Store' className={className} />;
  }

  return (
    <a href={href} target='_blank' rel='noopener noreferrer' tabIndex={tabIndex}>
      <img src={appleStoreImageUrl} alt='Download on the App Store' className={className} />
    </a>
  );
}
